import { DEFAULT_URL_CONFIG, ENVIRONMENTS, SEARCH_VERSION } from '../config';
import { url } from '../utils/url';
const BETTING_SEGMENT = 'betting';
const LOCALE_PARAM = 'locale=';
const LIMIT_PARAM = 'limit=';
const getLimitParam = (limit) => (limit ? LIMIT_PARAM + limit : '');
const getEnvironmentString = (environment) => environment === ENVIRONMENTS.pp1 ? '-pp1' : '';
const getSearchBaseUrl = (environment, jurisdiction) => `${DEFAULT_URL_CONFIG.searchBaseUrl}${getEnvironmentString(environment)}.${jurisdiction}/${SEARCH_VERSION}`;
const getLauncherBaseUrl = (environment, jurisdiction) => `${DEFAULT_URL_CONFIG.launcherBaseUrl}${getEnvironmentString(environment)}.${jurisdiction}`;
const getSportsbookBaseUrl = (environment, jurisdiction) => `${DEFAULT_URL_CONFIG.sportsbookBaseUrl}${getEnvironmentString(environment)}.${jurisdiction}`;
export function URLService({ environment, locale, jurisdiction, }) {
    const localeParam = LOCALE_PARAM + locale;
    const searchBaseUrl = getSearchBaseUrl(environment, jurisdiction);
    const launcherBaseUrl = getLauncherBaseUrl(environment, jurisdiction);
    const sportsbookBaseUrl = getSportsbookBaseUrl(environment, jurisdiction);
    const getSearchQueryUrl = ({ query, sportId, types, userToken, }) => {
        const sportQs = sportId ? url `&sport=${sportId}` : '';
        const typesQs = types ? url `&type=${types}` : '';
        const userTokenQs = userToken ? url `&userToken=${userToken}` : '';
        return `${searchBaseUrl}/?${localeParam}&q=${query}` + typesQs + sportQs + userTokenQs;
    };
    const getSearchSuggestionsUrl = (limit) => `${searchBaseUrl}/suggestions?${localeParam}&${getLimitParam(limit)}`;
    const getSearchXsellUrl = (limit) => `${searchBaseUrl}/xsell?${localeParam}&${getLimitParam(limit)}`;
    const getInsightsUrl = (eventType) => `${searchBaseUrl}/insights/${eventType}?${localeParam}`;
    const getCasinoLauncherUrl = (urlQuery) => launcherBaseUrl.replace(/\/+$/, '') +
        `/launch/${urlQuery}` +
        `&language=${locale.substring(0, 2)}` +
        url `&returnUrl=${location.href}`;
    const getSportsbookUrl = (path) => (path === null || path === void 0 ? void 0 : path.startsWith('/')) ? `${sportsbookBaseUrl.replace(/\/+$/, '')}${path}` : path || '';
    const getSportsbookRelativePath = (path, isCasino) => {
        const bettingSegment = `/${BETTING_SEGMENT}/`;
        if (isCasino || (path === null || path === void 0 ? void 0 : path.startsWith(bettingSegment)))
            return path || '';
        return `${bettingSegment}${locale}/${path || ''}`;
    };
    return {
        launcherUrl: launcherBaseUrl,
        searchUrl: searchBaseUrl,
        searchSportsUrl: searchBaseUrl + `/sports?${localeParam}`,
        getSportsbookUrl,
        getSearchQueryUrl,
        getSearchSuggestionsUrl,
        getSearchXsellUrl,
        getInsightsUrl,
        getCasinoLauncherUrl,
        getSportsbookRelativePath,
    };
}
//# sourceMappingURL=URLService.js.map